// The paste-ready MCP setup strings, in one place. Two surfaces hand these out —
// the Integrations "Create token" modal and the /connect wizard — and a client
// that works in one must work in the other, so the templates live here rather
// than being retyped per screen.

export const buildClaudeCodeCommand = (mcpUrl, token) =>
  `claude mcp add --transport http ultimate-web-scraper ${mcpUrl} --header "Authorization: Bearer ${token}"`;

export const buildMcpConfigJson = (mcpUrl, token) => `{
  "mcpServers": {
    "ultimate-web-scraper": {
      "url": "${mcpUrl}",
      "headers": { "Authorization": "Bearer ${token}" }
    }
  }
}`;

// For clients that can't set request headers — the token rides in the path.
export const buildTokenizedUrl = (mcpUrl, token) => `${mcpUrl}/t/${token}`;
